// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getCategoryListFailed, getCategoryListRequested, getCategoryListSucceeded } from './select-category.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';
import { Store } from '@ngrx/store';
import { selectCategoryListResponse } from './select-category.selectors';

@Injectable()
export class SelectCategoryEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCategoryListRequested),
      withLatestFrom(this.store.select(selectCategoryListResponse)),
      filter(([, response]) => response == null),
      exhaustMap(() => this.service.getCategoryList()
        .pipe(
          map((response) => getCategoryListSucceeded({response})),
          catchError(() => of(getCategoryListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
    private store: Store,
  ) {
  }
}
